module.exports = __webpack_public_path__ + "static/media/job-sel.e7eafc42.svg";